import {AxiosError} from 'axios';
import {useQuery} from 'react-query';
import {toast} from 'react-toastify';

import {
  getSupplierPostStories,
  getSupplierStories,
} from './../../../../services/newShop/home/story';

export const useGetSupplierStories = () => {
  const {data: stories, isLoading: storiesIsLoading} = useQuery(
    ['story'],
    getSupplierStories,
  );

  return {stories, storiesIsLoading};
};

export const useGetPostStories = (guid?: string) => {
  const {data: postsStory, isLoading} = useQuery(
    ['story-post', guid],
    getSupplierPostStories,
    {
      enabled: !!guid,
      onError: (error: AxiosError<{message: string}>) => {
        toast.error(
          error.response?.data?.message || 'خطای ناشناخته‌ای رخ داده است',
        );
      },
    },
  );

  return {postsStory, isLoading};
};
